import { Flex, Grid, Link, Text, Image } from '@chakra-ui/react';
import React, { useEffect } from 'react'
import { useSelector } from 'react-redux';
import { getStudentSubmittedAssignments } from '../../../action/studentAction';
import { StateType, useStudentAuthDispatch } from '../../../store/store';
import Doc from "../../../images/teacher/doc.svg";

function Submitted() {
  const dispatch = useStudentAuthDispatch();
  const { data: { token }, submittedAssignments } = useSelector((state: StateType) => state.rootReducer.studentReducer);
  const studentToken = token.includes("Bearer") ? token.slice(17, (token.length - 2)) : token.slice(10, (token.length - 2));
  console.log(submittedAssignments);

  useEffect(() => {
    dispatch(getStudentSubmittedAssignments(studentToken))
  }, [])

  return (
    <div>
      <Flex flexDirection={"column"} boxShadow="2xl" m={7} p={5} borderRadius={"20px"}>
      <Text textTransform={"capitalize"} fontWeight={"extrabold"} fontSize={"2xl"}>Submitted Assignments</Text>
      <Grid gridTemplateColumns={"repeat(auto-fit, minmax(250px, 1fr))"} justifyContent={"center"}>
        {submittedAssignments.map((assignment, index) => (
            assignment.course_id === "" ? (
              <Text key={index} textTransform={"capitalize"} textAlign={"center"}>No Submitted Assignments</Text>
            ) : (
              <Flex key={assignment.assignment_link} bgColor={"brand.white"} flexDirection={"column"} m={4} borderRadius={"20px"} p={6}>
                <Text textTransform={"capitalize"} fontWeight={"extrabold"}
                      fontSize={"lg"}>{assignment.course_name}</Text>
                <Link href={assignment.assignment_link} download my={3}>
                  <Image
                    title={"document"}
                    src={Doc}
                    alt={"document icon"}
                    boxSize={"30px"}
                    mr={1}
                    d={"inline-block"}
                  />
                  {assignment.course_name}{" "}{index + 1}
                </Link>
                <Text fontWeight={"semibold"} fontSize={"xs"}>Score: {assignment.assignment_score === null ? "not scored" : assignment.assignment_score }</Text>
                <Flex justifyContent={"flex-end"}>
                  <i title={"Delete"} className="fa fa-trash fa-1x fa-red" aria-hidden="true">
                  </i>
                </Flex>
              </Flex>
            )
          )
        )}
      </Grid>
    </Flex>
    </div>
  )
}

export default Submitted
